// src/langurage/zh.js 
// 定义越南语言包对象
export default {
  button: {
    add: 'Thêm mới',
    delete: 'Xóa',
    edit: 'Sửa',
    save: 'Lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    back: 'Quay lại',
    search: 'Tìm kiếm',
    refresh: 'Làm mới',
    reset:'Cài lại',
    MergeIssue:'Kết hợp và phát hành',

    issue:'phát hành',
    signFor:'ký nhận',
    delete:'xóa',
    details:'chi tiết',
    point:'chỉ hóa”',
    photos:'chụp ảnh'
    },
    radio:{
      shipment:'gửi hàng',
      delivery:'nhận hàng',
      total:'tất cả'
    },
    form:{
      startTime:'Giờ bắt đầu',
      endTime:'Giờ kết thúc',
      BusinessType:'Loại vụ kinh doanh',
      DeliveryOrder:'Tìm kiếm số đơn',
      VehicleLicense:'Tra cứu số đơn',
      DriverName:'Tra cứu tên tài xế”'
    },
    columns: {
      name: 'tên',
      company: 'công ty',
      address: 'địa chỉ',
      phone: 'số điện thoại',
    },      
    navigateBar: {
      hotspot: '热点',
      experience: '经验',
      focus: '关注',
      recommend: '推荐'
    },
    tabs: {
      work: '作品',
      private: '私密',
      collect: '收藏',
      like: '喜欢'
    },
    taskDeliveryPlaceholder:{
      selectStartTime:'Chọn thời gian bắt đầu”“Lựa chọn thời gian bắt đầu',
      SelectEndtime:'Chọn thời gian kết thúc”“Lựa chọn thời gian kết thúc',
      deliveryOrder:'Vui lòng nhập số đơn giao hàng',
      licensePlate:'Vui lòng nhập biển số xe',
      drivername:'Vui lòng nhập tên tài xế',
    },
    taskDeliverycolumns: {
      Serial:'Số hiệu',
      DeliveryOrder:'Số phiếu giao hàng',
      WaybillNumber:'Số đơn vận chuyển',
      LicensePlate:'Biển số xe',
      DriverName:'Tên tài xế',
      Remarks:'Ghi chú',
      WarehouseOrder:'Số đơn kho',
      CreationTime:'Thời gian lập',
      BusinessType:'Loại vụ kinh doanh',
      Status:'Tình trạng',
      Operation:'Thao tác'
    },
  }